import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { WizardComponent } from 'angular-archwizard';
import { get, isEmpty, pull } from 'lodash';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { take } from 'rxjs/operators';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { CustomValidators } from 'ngx-custom-validators';
import { strictCardNumberRegex } from 'src/app/core/model/regex';
import { CommonService } from 'src/app/providers/common.service';
import { parsePhoneNumber } from "libphonenumber-js";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { environment } from "../../../../../environments/environment";
import { BehaviorSubject, Subject } from "rxjs";
import { InformationModalComponent } from 'src/app/shared/components/information-modal/information-modal.component';
import { AuthService } from 'src/app/providers/auth.service';
import { Modules } from 'src/app/core/model/modules.enum';
import { Privileges } from 'src/app/core/model/privileges.enum';
import { ACH_ALTERNATE_PROCESSOR_CODE, ACH_ALTERNATE_PROCESSOR_CODES } from 'src/app/global/constants';
import { VericheckAchComponent } from '../../virtual-terminal/vericheck-ach/vericheck-ach.component';
@Component({
  selector: 'app-merchant-contract-billing',
  templateUrl: './merchant-contract-billing.component.html',
  styleUrls: ['./merchant-contract-billing.component.scss']
})
export class MerchantContractBillingComponent implements OnInit {
  @ViewChild('wizard', { static: false }) wizard: WizardComponent;
  @ViewChild('payaConfirmation') payaConfirmation: ElementRef;
  @ViewChild('addBankModal') addBankModal: ElementRef;
  @ViewChild(VericheckAchComponent) vericheckAchComponent?: VericheckAchComponent;
  
  payaOptionModalRef: NgbModalRef;
  addBankModalRef: NgbModalRef;
  cloudPOSForms: UntypedFormGroup;
  
  public isAddMerchant: boolean = false;
  public conractForm: any = {};
  merchantId: any;
  isDisable: boolean  = true;
  paymentType: { key: string; value: string }[] = [];
  deliveryForm!: FormGroup;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.India,
  ];
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  selectedPhoneCountryCode: any = CountryISO.UnitedStates;
  separateDialCode = true;
  maxLen = 10;
  isEnabled:boolean = true;
  payaModelForm: UntypedFormGroup;
  isPayaEnabled = false;
  ppdOrCcdValidationLoading = false;
  payaOptionDisable = { optionOneDisable: true, optionTwoDisable: true };
  tokenObj;
  selectedPayaOption = '';
  achProcessorInfo: any;
  availableSecCodes = [];
  isPayaACHEnabled = false;
  ppdOrCcdOptions = [];
  collectionAccountTpn:any;
  public conractFormLoader: string = 'true';
  paymentCardDetails: any;
  paymentDetails: any;
  isAchEnable: boolean = false;
  eBill: boolean = false;
  payaValidationDetails: any;
  private payaValidation = new BehaviorSubject<any>({});
  payaResponseValidation$ = this.payaValidation.asObservable();
  private payaFormReseter = new BehaviorSubject<any>({});
  payaRest$ = this.payaFormReseter.asObservable();
  vericheckTransactionPasser = new Subject<any>();
  vericheckTransaction$ = this.vericheckTransactionPasser.asObservable();
  vericheckAddAchPasser = new Subject<any>();
  vericheckAddAchTransaction$ = this.vericheckAddAchPasser.asObservable();
  vericheckResetPasser = new Subject<any>();
  vericheckReset$ = this.vericheckResetPasser.asObservable();
  merDba:any;
  isMerchantBillingEnable: Number;
  disable: boolean =  false;
  public queryParams: any = this.activeRoute.snapshot.queryParams;
  consumerId: any;
  submitLoader : Boolean = false;
  loader : Boolean = false;
  ppdOrCcdOptionsArray = [];
  defautTerminalType = null;
  PayaTxValidation: any = {};
  alternateCardDetails: any = {};
  accountNumber :string = ''
  cardDetails :any = {};
  alternateCardDetailsLength = 0;
  previousState: any = null;
  achProcessorName : any;
  merchantDetails : any
  /** Template-safe alias for ACH processor API codes. */
  readonly achAltCode = ACH_ALTERNATE_PROCESSOR_CODE;
  achArrayList = [...ACH_ALTERNATE_PROCESSOR_CODES];
  isLoading: boolean = true;
  achLoader: Boolean = false;
  loading :boolean = false;
  isfromRunASale = false;
  isPhoneisMandatory: string = "";
  public editBilling: boolean = this.isAccess(Modules.MERCHANT_BILLING, Privileges.EDIT_BILLING)



  public billingConfigForm: FormGroup = new FormGroup({ isEnabledControl: new FormControl() })
  achURLList: any;
  constructor(
    private activeRoute: ActivatedRoute,
    public router: Router,  
    private fb: FormBuilder,
    private common: CommonService,
    private ngbModal: NgbModal,
    private messageService: MessageService,
    private authService: AuthService 
  ) {

  }

  ngOnInit(): void {

    this.activeRoute.queryParams.subscribe((params) => {
      this.merchantId = params['mid'];
      this.isAddMerchant = params['isadd'] === 'true';
      this.merDba = params['merDba'];
      this.eBill = params['ebill'] === 'true';
    });
    this.payaModelForm = this.createPayaModelForm();
    this.cloudPOSForms = this.createCloudPOSForms();

    this.deliveryForm = this.fb.group({
      paymentMethod: ["PAYMENT_LINK", Validators.required],
      email: ["",
        [
          Validators.required,
          CustomValidators.email,
        ],
      ],
      phone: [null, [Validators.required]],
    });


    this.contractFormFn({ invalid: true, value: {} });
    this.billingConfigForm.get('isEnabledControl')?.valueChanges.subscribe((val: boolean) => {
      this.isEnabled = val;
    });
    this.isEnabled = this.billingConfigForm.get('isEnabledControl')?.value;
    this.getMerchantDetails();
    this.getPaymentDetails();
    if(!this.editBilling){
      this.deliveryForm.disable();
      this.billingConfigForm.get('isEnabledControl').disable()
    }
    // this.achCheck()
    // this.buildPaymentTypeOptions();
    // this.getAllAlternateProcessorIso();    
    // this.previousState = this.deliveryForm.get('paymentMethod').value;
  }

   createCloudPOSForms(): UntypedFormGroup {
      return this.fb.group({
        paymentInfo: this.paymentInfoForm(),
      });
    }

     paymentInfoForm(): UntypedFormGroup {

    return this.fb.group({
      paymentMode: ['', []],
      amt: ["", [Validators.required, CustomValidators.gt(0)]],
      email: ["", [CustomValidators.email]],
      phone: ["", []],
      cardNumber: ["", [Validators.required, Validators.pattern(strictCardNumberRegex)]],
      expDate: ["", [Validators.required]],
      cvv: ["", [Validators.minLength(3)]],
      zipCode: ["", []],
      Invoice: ["", [Validators.pattern('^[a-zA-Z0-9]{1,12}$')]],
      street: ["", [Validators.pattern('^[A-Za-z0-9]{1}[a-zA-Z0-9 \\s,.\\/-]{1,29}$')]],
      cardHolderName: ["", [Validators.pattern('^[a-zA-Z ]{1,26}$')]],
      unMaskedCardNumber: ["", []],
      unMaskedExpDate: ["", []],
      description: ["", [Validators.maxLength(100)]],
      fortInvoiceNum: ["", []],
      purchaseOrderNumber: ["", []]
    })
  }

  createPayaModelForm(): UntypedFormGroup {
    return this.fb.group({
      selectedOption: ['', [Validators.required]]
    })
  }
  
  onOptionClicked(item: any) {
    if (item.value != 'BANK') {
      this.previousState = this.deliveryForm.get('paymentMethod').value;
      return
    } else {
      this.achCheck();
      return;
    }
  }

  dialogFn = async () => {
    this.addBankModalRef = this.ngbModal.open(this.addBankModal, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false, size: 'lg' });
  }
  openPayaModal() {
    this.payaOptionModalRef =  this.ngbModal.open(this.payaConfirmation, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false});
  }

 onChangeToggule(event: boolean) {
  if (!event) {
    const modalRef = this.ngbModal.open(InformationModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.enable2buttons = true;
    modalRef.componentInstance.header = 'Disable Invoicing Confirmation';
    modalRef.componentInstance.innerHtmlContent = `Are you sure you want to disable invoicing for this merchant?<br>
   <div class="alert alert-warning mt-3 text-left" role="alert"> <b>Please note:</b> This action is immediate and the merchant will not be prorated for the current month.</div>`;
    modalRef.componentInstance.buttonName = 'Confirm';
    modalRef.componentInstance.closeBtnName = 'Cancel';

    modalRef.closed.subscribe((value: string) => {
      if (value === 'success') {
        this.common.postCommonHttpClient(apiLinks.merchantBilling.disableBilling, { merchantId: this.merchantId}).pipe(take(1)).subscribe({
          next: (res: any) => {
            this.showToaster('success', '', 'Billing disabled for this merchant.');
            this.isEnabled = false;
            this.billingConfigForm.get('isEnabledControl')?.patchValue(false);
            this.disable = true;
          },
          error: (err) => {
            console.error('Error disabling billing:', err);
            this.showToaster('error', 'Error', 'Failed to disable billing.');
            this.billingConfigForm.get('isEnabledControl')?.patchValue(true);
          }
        });
      } else {
        this.billingConfigForm.get('isEnabledControl')?.patchValue(true);
        this.disable = true;
      }
    });
  } else {
    this.common.postCommonHttpClient(apiLinks.merchantBilling.enableBilling, { merchantId: this.merchantId }).pipe(take(1)).subscribe({
      next: (res: any) => {
        // this.showToaster('success', '', res?.message || 'Billing enabled for the merchant.');
        this.isEnabled = true;
        this.getPaymentDetails();
        this.billingConfigForm.get('isEnabledControl')?.patchValue(true);
      },
      error: (err) => {
        console.error('Error enabling billing:', err);
        this.showToaster('error', 'Error', 'Failed to enable billing.');
        this.billingConfigForm.get('isEnabledControl')?.patchValue(false);
        this.isEnabled = false;
      }
    });
  }
}


  goBack() {
    if (this.queryParams?.backtopage == 'm-b-invoice-details') {
      window.history.back();
      return
    }
    this.router.navigate(["/merchant-management/list-merchant"]);
  }

  savePaymentDetails = () => {
    if (this.deliveryForm.invalid) {
      this.deliveryForm.markAllAsTouched();
      return;
    }
    let { customerId } = this.paymentDetails?.collectionAccountDetails;
    const selectedValue = this.deliveryForm.get('paymentMethod')?.value;

    let matchedCard: any = null;
    let matchedAltCard: any = null;

    for (const item of this.paymentCardDetails) {
      matchedCard = item.cardDetails?.find(card => card.cardNum === selectedValue);
      matchedAltCard = item.alternateCardDetails?.find(alt => alt.accountNum === selectedValue);

      if (matchedCard || matchedAltCard) break;
    }

    const selectedOption = this.paymentType.find(option => option.value === selectedValue);

    let paymentMethod = selectedOption?.key || null;
    let paymentType: 'CARD' | 'BANK' | 'PAYMENT_LINK' | null = null;

    if (selectedValue === 'PAYMENT_LINK') {
      paymentType = 'PAYMENT_LINK';
      paymentMethod = 'PAYMENT_LINK';
    } else if (selectedValue === 'BANK') {
      paymentType = 'BANK';
    } else if (paymentMethod?.startsWith('Card')) {
      paymentType = 'CARD';
    } else if (paymentMethod?.startsWith('ACH')) {
      paymentType = 'BANK';
    }

    let reqObj = {
      customerId,
      merchantId: this.merchantId,
      consumerId: this.consumerId,
      template: {
        ...this.conractForm.value
      },
      action: 'bulk_enable',
      paymentType,
      paymentMethod,
      contractEmail: this.deliveryForm.get('email')?.value,
      contractPhone: this.deliveryForm.get('phone')?.value?.e164Number,
      "alternateCardDetails": matchedAltCard  || null,
      "cardDetails": matchedCard || null,
      alternateProcessorCode: null
    };

    if(paymentType == 'BANK'){
     reqObj.alternateProcessorCode = matchedAltCard?.alternateProcessorCode ? matchedAltCard.alternateProcessorCode : (this.achArrayList?.includes(this.achProcessorName) ? this.achArrayList?.[0] : '');
 
    }
    
    this.submitLoader = true;
    console.log("🚀 ~ MerchantContractBillingComponent ~ reqObj:", reqObj)
    this.common.postCommonHttpClient(apiLinks.merchantBilling.billingEnableById, reqObj).pipe(take(1)).subscribe((res: any) => {

      this.submitLoader = false;
       this.showToaster('success', '', 'Contract saved Successfully.');
       this.loader = true;
       this.goBack();

    }, error => {
      this.submitLoader = false;
      this.showToaster('error', '', 'Contract saved Failed.');
      this.loader = false;
    })

  }

  contractFormFn = (contract: any) => {
    this.isDisable = false;
    this.conractForm = contract;
    this.billingConfigForm.get('isEnabledControl').enable();
  }

  contractFormLoaderFn = (loader: string) => {
    this.conractFormLoader = loader;
  }
bankStatus :string = '';
statusForm : boolean = false;
isSuccess: boolean = false;

  getPaymentDetails = (isCompleteAddBank = false) => {

    let param = {};
    param['merchantId'] = this.merchantId;
    if(this.eBill && this.editBilling) {
      param['editBilling'] = true;
    };
    this.common.getCommonHttpClientQueryParams(apiLinks.merchantBilling.paymentDetail, param).pipe(take(1)).subscribe((res: any) => {
      this.paymentDetails = res.data
      this.paymentCardDetails = this.paymentDetails.paymentCardDetails || [];
      this.consumerId = this.paymentDetails?.collectionAccountDetails?.consumerId;
      
      if (isCompleteAddBank) {
        this.isAchEnable = true;
        this.buildPaymentTypeOptions();

        const allAltCards = this.paymentCardDetails.flatMap(item => item.alternateCardDetails || [])
          .filter(card => card?.createdAt)
          .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

        const latestCard = allAltCards[0];

        if (latestCard?.accountNum) {
          this.deliveryForm.get('paymentMethod')?.patchValue(latestCard.accountNum);
          this.accountNumber = latestCard.accountNum;
        } else {
          this.deliveryForm.get('paymentMethod')?.patchValue('PAYMENT_LINK');
        }
        this.loading = false;
        this.isSuccess = true;
        this.statusForm = true;
        this.bankStatus = "Bank Added Successfully."
        if(!this.payaOptionDisable.optionOneDisable && !this.payaOptionDisable.optionTwoDisable){
        this.payaModelForm.reset()
      }
         this.addBankModalRef?.close();
        return;
      }
      this.deliveryForm.get('email')?.patchValue(this.paymentDetails.billingConfiguration?.contractEmail || this.merchantDetails.email || '');
      this.deliveryForm.get('phone')?.patchValue(this.getPhoneNumberAndCountryCode(this.paymentDetails.billingConfiguration?.contractPhone || this.merchantDetails.phoneNumber ||''));

      this.getAllAlternateProcessorIso();
      this.isAchEnable = this.paymentDetails.achStatus === 1;
      this.buildPaymentTypeOptions();
 
    }, (error) => {
       console.log("getPaymentDetails", error.message);
        this.isAchEnable = false;
        this.paymentCardDetails = [];
        this.paymentType = [{ key: 'Send Payment Link', value: 'PAYMENT_LINK' }];
        this.deliveryForm.get('paymentMethod')?.patchValue('PAYMENT_LINK');
        this.showToaster('error', '',  error?.message);
    })
  }

  buildPaymentTypeOptions() {
    let types: any[] = [];

    types.push({ key: 'Send Payment Link', value: 'PAYMENT_LINK' });

    if (Array.isArray(this.paymentCardDetails)) {
      this.paymentCardDetails.forEach(item => {

        if (Array.isArray(item.cardDetails) && item.cardDetails.length > 0) {
          item.cardDetails.forEach(card => {
            types.push({
              key: `Card (${card.cardNum})`,
              value: card.cardNum
            });
          });
        }
        if (this.isAchEnable && this.achArrayList.includes(this.achProcessorName)) {
          if (Array.isArray(item.alternateCardDetails) && item.alternateCardDetails.length > 0) {
            item.alternateCardDetails.forEach(card => {
              types.push({
                key: `ACH (${card.accountNum})`,
                value: card.accountNum
              });
            });
          }
        }
      });      
    }

    if (this.isAchEnable && this.achArrayList.includes(this.achProcessorName)) {
      types.push({ key: 'Add Bank', value: 'BANK' });
    }

    this.paymentType = types;
 
    const methodLabel = this.paymentDetails.billingConfiguration?.paymentMethod;

    const matchedItem = this.paymentType.find(pt => pt.key === methodLabel);

    if (matchedItem) {
      this.deliveryForm.get('paymentMethod')?.patchValue(matchedItem.value);
    } else {
      this.deliveryForm.get('paymentMethod')?.patchValue('PAYMENT_LINK'); 
    }
    this.previousState = this.deliveryForm.get('paymentMethod').value;

  }

  getPhoneNumberAndCountryCode(phoneNumber) {
    let phoneData;
    if (isEmpty(phoneNumber)) {
      return "";
    }
    try {
      phoneData = parsePhoneNumber(phoneNumber);
      this.selectedPhoneCountryCode = phoneData.country;
    } catch {
      phoneData = { nationalNumber: phoneNumber };
      this.selectedPhoneCountryCode = "US";
    }

    return phoneData.nationalNumber;
  }

  payaConfirmWithYes() {
    this.isPayaEnabled = true;
  }
  onFormCancelled() {
     this.isPayaEnabled = false;
      if(!this.payaOptionDisable.optionOneDisable && !this.payaOptionDisable.optionTwoDisable){
        this.payaModelForm.reset()
      }
     this.deliveryForm.get('paymentMethod').patchValue(this.previousState);
  }

  

  achCheck() {
    if(this.payaOptionDisable.optionOneDisable &&  this.payaOptionDisable.optionTwoDisable){
       this.showToaster('error', '', 'Only WEB ACH is currently enabled for this store. Please enable additional ACH transaction types (TEL, PPD, or CCD) to add a bank account.');
       this.deliveryForm.controls.paymentMethod.patchValue(this.previousState);
       return
    }
    let { storeId, consumerId } = this.paymentDetails?.collectionAccountDetails;
    this.deliveryForm.controls.paymentMethod.disable();
    this.achLoader = true;
    this.common.getCommonHttpClientQueryParams(`${apiLinks.PayaAch.addAchCheck}/${storeId}`, { consumerId: consumerId  }).subscribe(
      response => {
        this.collectionAccountTpn = response?.payaTpns[0];
        this.deliveryForm.controls.paymentMethod.enable();
        this.achLoader = false;
        if (this.collectionAccountTpn) {
          this.openPayaModal();
        }
        if (!response?.payaTpns?.length && this.paymentDetails?.storeId) {
          this.showAlertMessage('no ACH tpns!', 'success', 'Status', false);
          return;
        } 
      },
      error => {
         this.showToaster('error', '', error?.message);
         this.deliveryForm.controls.paymentMethod.enable();
         this.deliveryForm.controls.paymentMethod.patchValue(this.previousState);
         this.achLoader = false;
      })

  }

  async getAllAlternateProcessorIso() {

    let { merchantId, storeId, customerId } = this.paymentDetails?.collectionAccountDetails;
    this.achProcessorInfo = await this.getCustomerACHInformation({ customerId, merchantId, storeId, secCode: 'TEL',isCollection: true });

    this.achProcessorInfo = get(this.achProcessorInfo, 'message', false);
    this.availableSecCodes = get(this.achProcessorInfo, '[0].availableSecCodes', []);
    this.isPayaACHEnabled = get(this.achProcessorInfo, '[0].alternate_processor_from_customer_processor.code', false) == ACH_ALTERNATE_PROCESSOR_CODE.PAYA;
    // let isTel = this.checkIsTelOrNot(this.availableSecCodes);
    this.ppdOrCcdOptions = [...this.availableSecCodes];
    
    this.payaOptionDisable = { optionOneDisable: true, optionTwoDisable: true };
  
    this.ppdOrCcdOptions = pull(this.ppdOrCcdOptions, 'WEB', 'TEL');
    if (this.availableSecCodes.includes('TEL') && !this.availableSecCodes.includes('CCD') && !this.availableSecCodes.includes('PPD')) {
      this.payaModelForm.controls['selectedOption'].patchValue('1');
      this.payaOptionDisable = { optionOneDisable: false, optionTwoDisable: true };
    } else if (this.availableSecCodes.includes('TEL') && this.availableSecCodes.includes('CCD') && this.availableSecCodes.includes('PPD')) {
      this.payaModelForm.controls['selectedOption'].patchValue('');
      this.payaOptionDisable = { optionOneDisable: false, optionTwoDisable: false };
    } else if (this.availableSecCodes.includes('TEL') && (this.availableSecCodes.includes('PPD') || this.availableSecCodes.includes('CCD'))) {
      this.payaModelForm.controls['selectedOption'].patchValue('');
      this.payaOptionDisable = { optionOneDisable: false, optionTwoDisable: false };
    } else if (!this.availableSecCodes.includes('TEL') && (this.availableSecCodes.includes('PPD') || this.availableSecCodes.includes('CCD'))) {
      this.payaModelForm.controls['selectedOption'].patchValue('2');
      this.payaOptionDisable = { optionOneDisable: true, optionTwoDisable: false };
    }
    this.achProcessorName = get(this.achProcessorInfo,'[0].alternate_processor_from_customer_processor.code',false);
   
    if (this.achProcessorName == ACH_ALTERNATE_PROCESSOR_CODE.PAYA) {
      this.cloudPOSForms.get(['paymentInfo', 'paymentMode']).setValue('Paya ACH - ')
    } else if (this.achProcessorName == ACH_ALTERNATE_PROCESSOR_CODE.VERICHECK) {
      this.cloudPOSForms.get(['paymentInfo', 'paymentMode']).setValue('Vericheck ACH - ')
    } else if (this.achProcessorName == ACH_ALTERNATE_PROCESSOR_CODE.ACH) {
      this.cloudPOSForms.get(['paymentInfo', 'paymentMode']).setValue('ACH - ')
    }
    this.buildPaymentTypeOptions(); 

  }

  async getCustomerACHInformation(payloads) {
    let achProcessorDetails = await this.common.getCommonHttpClientQueryParams(apiLinks.getAllAlternateProcessorIso, { ...payloads, }).toPromise()
      .catch(
        error => {
          this.showAlertMessage('error', 'Error', error.message, false);
        });
    return achProcessorDetails;
  }

  async onPayaModelSubmit() {
    console.log("Selected option:", this.payaModelForm.get('selectedOption').value);

    this.tokenObj = {
      validation: null,
      terminalId: null,
      validationID: null,
      defautTerminalType: null
    }
    if (!this.payaModelForm.valid) {
      return false;
    } else {
      this.selectedPayaOption = this.payaModelForm.get('selectedOption').value;
      if (this.achProcessorName === ACH_ALTERNATE_PROCESSOR_CODE.VERICHECK) {
        this.payaOptionModalRef.close();
        this.dialogFn();
        return;
      }
      if (this.selectedPayaOption == '2') {
        this.ppdOrCcdValidationLoading = true;
        let { merchantId, storeId, customerId } = this.paymentDetails?.collectionAccountDetails;

        this.common.getCommonHttpClientQueryParams(apiLinks.PayaAch.ppdAndCcd, { customerId, merchantId, storeId }).subscribe(data => {
          this.payaValidationDetails = get(data, 'message',);
          this.ppdOrCcdValidationLoading = false;
          this.payaOptionModalRef.close();
          console.log("🚀 ~ MerchantContractBillingComponent ~ onPayaModelSubmit ~ this.ppdOrCcdOptions:", this.ppdOrCcdOptions)
          this.ppdOrCcdOptionsArray = this.ppdOrCcdOptions.map(data => {
            return { name: data, displayName: environment?.payaEntryClasses[data.toUpperCase()] || data };
          })
          
          if (this.ppdOrCcdOptions.length == 1) {
            let availableOption = this.ppdOrCcdOptions[0];
            this.defautTerminalType = availableOption;
            let validation = get(data, `message.PayaTxValidation.${availableOption.toLowerCase()}Validation`,);
            let terminalId = get(data, `message.PayaTxValidation.${availableOption.toLowerCase()}TerminalID`,);
            let PayLoadSchemaUsersID = get(data, 'message.PayLoadSchemaUsersID.users_id',);
            this.commonPayaValidation(validation, terminalId, PayLoadSchemaUsersID);
            this.tokenObj.validation = validation;
            this.tokenObj.terminalId = terminalId;
            this.tokenObj.validationID = PayLoadSchemaUsersID;
            this.tokenObj.defautTerminalType = this.defautTerminalType;
            this.tokenObj.ppdOrCcdOptionsArray = this.ppdOrCcdOptionsArray;
            this.tokenObj.selectedPayaOption = this.selectedPayaOption;
          }
          this.dialogFn();
        }, error => {
          if (error)
            this.ppdOrCcdValidationLoading = false;
            this.showAlertMessage('error', 'Error', error.message, false);
        })


      } else {
        this.payaOptionModalRef.close();
        if (this.achProcessorInfo) {
          this.PayaTxValidation = get(this.achProcessorInfo, '[0].PayaTxValidation', false);
          let terminalId = get(this.achProcessorInfo, '[0].payaProcessorData.TerminalID',);
          let PayLoadSchemaUsersID = get(this.achProcessorInfo, '[0].PayLoadSchemaUsersID.Users_id',);
          this.commonPayaValidation(this.PayaTxValidation, terminalId, PayLoadSchemaUsersID);
          this.tokenObj.validation = this.PayaTxValidation;
          this.tokenObj.terminalId = terminalId;
          this.tokenObj.validationID = PayLoadSchemaUsersID;
          this.tokenObj.defautTerminalType = null;
          this.tokenObj.selectedPayaOption = this.selectedPayaOption;
        }
        this.dialogFn();
      }
    }
  }

  commonPayaValidation(PayaTxValidation, terminalId, validationID) {
    this.payaValidation.next({ validation: PayaTxValidation, terminalId: terminalId, validationID: validationID });
  }
    payaTransactionPasser = new Subject<any>();
    payaTransaction$ = this.payaTransactionPasser.asObservable();

  payaTransaction() {
    let transObj = {
      isFromTransaction: true,
      tokenObj: this.tokenObj
    };
    this.payaTransactionPasser.next(transObj);
  }

  showAlertMessage(alertType, summary, data, sticky) {
    this.messageService.clear();
    this.messageService.add({
      severity: alertType,
      summary: summary,
      detail: data,
      sticky: sticky
    });
  }

  showToaster(type, define, message) {
    this.messageService.add({
      severity: type,
      summary: define,
      detail: message,
      key: 'copy-toast'
    });
  }

  getExstingCustomerPayload(accountNum){
    this.payaTransactionPasser.next({isfromExstingPayload : true});
  }

  async addBank(formData){
    this.loading = true;
    console.log("🚀 ~ MerchantContractBillingComponent ~ addBank ~ formData:", formData)
    await this.common.postCommonHttpClient(`${apiLinks.PayaAch.addAch}/${this.consumerId}`, { ...formData, isMerchantBilling: true }).toPromise().then(res => {
       
       this.getPaymentDetails(true);
       this.showToaster('success', '', 'Bank Added Successfully.');
      }, err => {
       this.loading = false;
       this.statusForm = true;
       this.isSuccess = false;
       this.bankStatus = "Bank Added Failed."
       this.showToaster('error', '', err?.message);
      });
      return;
    }

  submitActiveAddBank() {
    if (this.achProcessorName === ACH_ALTERNATE_PROCESSOR_CODE.VERICHECK) {
      this.loading = true;
      this.vericheckAddAchPasser.next({ isFromAddAchBank: true });
      return;
    }
    this.payaTransaction();
  }

  resetActiveAddBankForm() {
    if (this.achProcessorName === ACH_ALTERNATE_PROCESSOR_CODE.VERICHECK) {
      this.loading = false;
      this.vericheckResetPasser.next({ isReset: true });
      return;
    }
    this.onRestFormPaya();
  }

  handleVericheckFormData(formData: any) {
    if (get(formData, 'showError')) {
      this.loading = false;
      if (get(formData, 'isClientValidation')) {
        return;
      }
      const apiErr = get(formData, 'err');
      if (apiErr) {
        const errMsg = get(formData, 'err.message', 'Unable to add bank account.');
        this.showToaster('error', 'Error', errMsg);
      }
    }
  }

  getConsumersToken(_: any = null) {
    return;
  }

  clearUnMaskedAlternateCardData() {
    this.alternateCardDetails = {};
    this.alternateCardDetailsLength = 0;
  }

  buildVericheckGetHsmTokenUrl() {
    return '';
  }

  isDisableReset() {
    return false;
  }

  onVericheckAddBankCompleted() {
    this.getPaymentDetails(true);
    this.showToaster('success', '', 'Bank Added Successfully.');
  }

  onRestFormPaya() {
    this.payaFormReseter.next(true);
  }
    
  ppdOrCcdSelection(value) {
    let { selectedData } = value;
    if (selectedData) {
      let validation = get(this.payaValidationDetails, `PayaTxValidation.${selectedData.toLowerCase()}Validation`,);
      let terminalId = get(this.payaValidationDetails, `PayaTxValidation.${selectedData.toLowerCase()}TerminalID`,);
      let PayLoadSchemaUsersID = get(this.payaValidationDetails, 'PayLoadSchemaUsersID.users_id',);
      this.commonPayaValidation(validation, terminalId, PayLoadSchemaUsersID);
    }
  }


  isPayaChecker(value: any) {
    const isPaya = value.isPaya;
    if (isPaya) {
      this.isPhoneisMandatory = "*";
    } else {
      this.isPhoneisMandatory = "";
    }
  }
  
  closeAddBank() {
    this.loading = false;
    this.deliveryForm.get('paymentMethod').patchValue(this.previousState);
    if (!this.payaOptionDisable.optionOneDisable && !this.payaOptionDisable.optionTwoDisable) {
      this.payaModelForm.reset()
    }
    this.vericheckResetPasser.next({ isReset: true });
    this.ngbModal.dismissAll()
  }
  
  getMerchantDetails() {
  this.common.getCommonHttpClientQueryParams(`${apiLinks.merchantBilling.getMerchant}/${this.merchantId}`, {})
    .pipe(take(1))
    .subscribe({
      next: (res) => {
        const data = res?.data;
        if (data) {
          this.merchantDetails = data;
          this.isMerchantBillingEnable = data.isMerchantBillingEnabled;

          const enabled = this.eBill ? this.isMerchantBillingEnable === 1 : true;
          this.billingConfigForm.get('isEnabledControl')?.patchValue(enabled);
          this.isEnabled = enabled;
          this.disable = this.isMerchantBillingEnable === 1 ? false : true;
           if (enabled) {
            this.billingConfigForm.get('isEnabledControl')?.disable();
          }
          this.deliveryForm.get('email')?.patchValue(data.email || '');
          this.deliveryForm.get('phone')?.patchValue(this.getPhoneNumberAndCountryCode(data.phoneNumber || ''));

          this.cloudPOSForms.get(['paymentInfo', 'email'])?.setValue(data.email || '');
          this.cloudPOSForms.get(['paymentInfo', 'phone'])?.setValue(data.phoneNumber || '');
          this.cloudPOSForms.get(['paymentInfo', 'amt'])?.setValue('0.00');
           this.isLoading = false;
        } else {
          this.showToaster('warning', 'No Data', 'Merchant data not found.');

        }
      },
      error: (err) => {
        console.error('Error fetching merchant details:', err);
        this.showToaster('error', 'Error', 'Failed to load merchant details. Please try again later.');
      }
    });
}

 isAccess(module, privileges) {
    return this.authService.isFeatureEnabled(module, privileges);
  }

}
